module.exports = __webpack_public_path__ + "media/images/icons/icn_011-971fd368cdf14ed642fe3e70386ee594.svg";